import React from 'preact/compat'
import type { DialogComponentPropTypes } from '../AuthDialog'
import Api from '../../../api'
import cn from 'classnames'
import BackButton from '../BackButton'
import styles from '../../../../css/auth.pcss.json'
import styles2fa from '../../../../css/2fa.pcss.json'
import buttonsCss from '../../../../css/buttons.pcss.json'
import formCss from '../../../../css/form.pcss.json'
import { captureException, loadStylesheet } from '../../../common/helpers'
import { showToast } from '../../toast'

interface StateTypes {
  sending: boolean,
  error: boolean,
  removal: boolean
}

export default class PageMfaVerify extends React.Component<DialogComponentPropTypes, StateTypes> {
  state: StateTypes = {
    sending: false,
    error: false,
    removal: false
  }

  componentWillMount() {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('2fa')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('buttons')
  }

  onSubmit = (event: React.TargetedEvent<HTMLFormElement>) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    this.setState({
      sending: true
    })
    Api.post({
      url: 'auth/validate-mfa',
      body: formData
    })
      .then(response => {
        if (response.success) {
          window.location.reload()
          return
        }
        if (response.inputError) {
          this.setState({
            error: true,
            sending: false
          })
          return
        }
        showToast({
          type: 'error',
          text: response.error
        })
        this.setState({
          sending: false
        })
      })
      .catch(e => {
        captureException('Mfa Verify', e)
        showToast({
          type: 'error',
          text: 'При проверке кода произошла ошибка'
        })
        this.setState({
          sending: false
        })
      })
  }

  onInput = () => {
    const { error } = this.state
    if (error) {
      this.setState({
        error: false
      })
    }
  }

  goBack = () => this.props.switchPage('index')

  remove2fa = () => {
    Api.post({ url: 'auth/remove-2fa-via-email' })
      .then((response) => {
        if (response.success) {
          this.setState({
            removal: true
          })
          return
        }
        showToast({
          type: 'error',
          text: response.error
        })
      })
      .catch(e => {
        captureException('Mfa Verify', e)
        showToast({
          type: 'error',
          text: 'При отправке письма произошла ошибка'
        })
      })
  }

  render() {
    const { sending, error, removal } = this.state

    if (removal) {
      return <>
        <BackButton goBack={this.goBack}/>
        <p>Тебе на почту были высланы инструкции по отключению двухфакторной аутентификации</p>
      </>
    }

    return <>
      <BackButton goBack={this.goBack}/>
      <div className={styles['auth-header']}>
        <h1>Двухфакторная аутентификация</h1>
      </div>
      <form onSubmit={this.onSubmit} className={styles2fa['form']}>
        <input
          type='text'
          name='otp'
          onInput={this.onInput}
          pattern='\d{6}'
          required
          className={cn(formCss['input'], styles2fa['input'], {
            [formCss['input--error']]: error
          })}
          placeholder='Код из приложения'
          title='Шесть цифр без пробелов'
          autocomplete="one-time-code"
        />
        {error && <span class={styles2fa['error']}>Неверный код</span>}
        <button type='submit' className={cn(buttonsCss['primary'], styles2fa['button'])} disabled={sending}>
          Войти
        </button>
        <button
          onClick={this.remove2fa}
          type="button"
          className={styles['auth-forgot-password-button']}
        >
          У меня больше нет приложения
        </button>
      </form>
    </>
  }
}
